import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import API from "../../api/api";

export default function ArticleList() {
    const [articles, setArticles] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const fetchArticles = (pageNumber = 1) => {
        API
            .get(`/api/articles/allarticles?page=${pageNumber}`)
            .then(res => {
                setArticles(res.data.articles);
                setTotalPages(res.data.total_pages);
            })
            .catch(err => console.log(err));
    };

    useEffect(() => {
        fetchArticles(page);
    }, [page]);

    const deleteArticle = async (slug) => {
        if (!window.confirm("Delete this article?")) return;

        await API.delete(`/api/articles/${slug}`);
        fetchArticles(page); // refresh current page
    };

    return (
        <DashboardLayout>
            <div className="bg-white rounded-lg shadow border">

                {/* HEADER */}
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-lg font-bold text-gray-800">
                        All Articles
                    </h2>

                    <Link
                        to="/dashboard/articles/create"
                        className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700">
                        + New Article
                    </Link>
                </div>

                {/* TABLE */}
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50 text-gray-600">
                            <tr>
                                <th className="p-3 text-left">Title</th>
                                <th className="p-3">Sports</th>
                                <th className="p-3">Category</th>
                                <th className="p-3">Views</th>
                                <th className="p-3">Created</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {articles.map(article => (
                                <tr key={article.id} className="border-t hover:bg-gray-50">
                                    <td className="p-3 font-medium">
                                        {article.title}
                                    </td>
                                    <td className="p-3 text-center">
                                        {article.sport}
                                    </td>

                                    <td className="p-3 text-center">
                                        {article.category}
                                    </td>

                                    <td className="p-3 text-center">
                                        {article.views}
                                    </td>

                                    <td className="p-3 text-center">
                                        {new Date(article.created_at).toLocaleDateString()}
                                    </td>

                                    <td className="p-3 text-center space-x-2">
                                        <Link
                                            to={`/dashboard/articles/edit/${article.slug}`}
                                            className="text-blue-600 hover:underline">
                                            Edit
                                        </Link>

                                        <button
                                            onClick={() => deleteArticle(article.slug)}
                                            className="text-red-600 hover:underline">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}

                            {articles.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="p-6 text-center text-gray-500">
                                        No articles found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div className="flex justify-between items-center p-4 border-t">
                    <button
                        disabled={page === 1}
                        onClick={() => setPage(prev => prev - 1)}
                        className="px-4 py-2 rounded border disabled:opacity-50">
                        Previous
                    </button>

                    <span className="text-sm text-gray-600">
                        Page {page} of {totalPages}
                    </span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage(prev => prev + 1)}
                        className="px-4 py-2 rounded border disabled:opacity-50">
                        Next
                    </button>
                </div>

            </div>
        </DashboardLayout>
    );
}
